'use client';

import { getDefaultLocale } from '../config/locale';

import { GlobalErrorContent } from '../component/client/error/GlobalErrorContent';

import IntlByLocaleProvider from '../container/provider/IntlByLocaleProvider';

/**
 * Root global-error document (issue #95). Moved verbatim from the shell's
 * `global-error.tsx`: Next replaces the entire document when the root layout
 * throws, so this client component owns the minimal `<html>`/`<body>`
 * skeleton and the intl provider around the shared error presentation. The
 * shell file keeps only the `'use client'` directive, the global stylesheet
 * side-effect import (an app-local asset), and the default re-export.
 */
export function GlobalErrorPage({ error }: { error: Error & { digest?: string } }) {
  const locale = getDefaultLocale();

  return (
    <html lang={locale}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body>
        <IntlByLocaleProvider locale={locale}>
          <GlobalErrorContent error={error} fullPage />
        </IntlByLocaleProvider>
      </body>
    </html>
  );
}
